module.exports = __webpack_public_path__ + "assets/img/trace_monitor.ebd01285.png";